import AddRoundedIcon from '@mui/icons-material/AddRounded';
import ClearIcon from '@mui/icons-material/Clear';
import { Button, Container, Modal, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { addOrganizationContact, selectContactList } from '../../redux/reducers/organizationReducer';

const initialState = {
  name: '',
  phone: '',
  email: '',
};

function AddContactModal({ handleClose }) {
  const { t } = useTranslation();
  const [details, setDetails] = useState(initialState);
  const [validationError, setValidationError] = useState(false);
  const contactList = useSelector(selectContactList);
  const dispatch = useDispatch();

  const handleChange = (event) => {
    const { name, value } = event.target;
    const newDetails = { ...details };
    newDetails[name] = value;
    setDetails(newDetails);
  };

  function validate(property, value) {
    switch (property) {
      case 'name':
        return value !== '' && !contactList.find((person) => person.name === value);
      default:
        return false;
    }
  }

  const handleSave = () => {
    if (validate('name', details.name)) {
      setValidationError(false);
      const email = details.email.toLowerCase();
      dispatch(addOrganizationContact({ ...details, email }));
      handleClose();
    } else {
      setValidationError(true);
    }
  };

  const handleCancel = () => {
    setValidationError(false);
    setDetails(initialState);
    handleClose();
  };

  return (
    <Modal open onClose={handleSave}>
      <Container variant="settingsModal" sx={{ display: 'flex', flexDirection: 'column' }} disableGutters>
        <Container variant="formContainer" disableGutters>
          <Stack spacing={2}>
            <Typography variant="h6">{t('person.contact.add')}</Typography>
            <TextField
              variant="outlined"
              subtype="signinField"
              onChange={handleChange}
              id="name"
              name="name"
              defaultValue={details.name}
              InputLabelProps={{
                shrink: true,
              }}
              label={t('person.modal.name')}
              required
              error={validationError && !validate('name', details.name)}
            />
            {validationError && !validate('firstName', details.name) && (contactList.find((contact) => contact.name === details.name)
              ? <Typography variant="error">{t('error.nameTaken')}</Typography>
              : <Typography variant="error">{t('error.emptyField')}</Typography>
            )}
            <TextField
              variant="outlined"
              subtype="signinField"
              onChange={handleChange}
              id="email"
              name="email"
              defaultValue={details.email}
              InputLabelProps={{
                shrink: true,
              }}
              label={t('person.modal.email')}
              required
            />
            <TextField
              variant="outlined"
              subtype="signinField"
              onChange={handleChange}
              id="phone"
              name="phone"
              defaultValue={details.phone}
              InputLabelProps={{
                shrink: true,
              }}
              label={t('person.modal.phone')}
              required
            />
          </Stack>
        </Container>
        <Container variant="buttonRow" disableGutters>
          <Stack direction="row" justifyContent="flex-end">
            <Button id='cancel' variant="text" startIcon={<ClearIcon />} onClick={() => handleCancel()}>
              {t('person.modal.buttonCancel')}
            </Button>
            <Button
              id='add'
              variant="contained"
              disabled={!details.name || !details.email || !details.phone}
              startIcon={<AddRoundedIcon />}
              onClick={() => handleSave()}
            >
              {t('person.contact.add')}
            </Button>
          </Stack>
        </Container>
      </Container>
    </Modal>
  );
}

export default AddContactModal;
